/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from '@angular/core';

/**
 * Return the global native browser window object
 * @returns native window object
 */
const getNativeWindow = (): any => window; // eslint-disable-line @typescript-eslint/no-explicit-any

@Injectable({
  providedIn: 'root',
})
export class WindowRef {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get nativeWindow(): any {
    return getNativeWindow();
  }
}
